import { FC } from 'react';

export type UnderlineIconProps = {};

export const UnderlineIcon: FC<UnderlineIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9998 2.66663V7.33329C11.9998 9.54243 10.209 11.3333 7.99984 11.3333C5.7907 11.3333 3.99984 9.54243 3.99984 7.33329V2.66663M2.6665 14H13.3332"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
